<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M0 0h16v16H0z" style="fill:none" fill="currentColor"/><path d="M5.851.9a.8.8 0 0 1 1.3 0l4.935 6.834A.8.8 0 0 1 11.435 9h-9.87a.8.8 0 0 1-.649-1.268z" style="fill:#2c59d9" transform="rotate(90 5.75 7.25)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-control-play',
});
</script>
